<template>
    <div class="ppv2-flex ppv2-flex-wrap ppv2-mb-8 ppv2-w-full" :style="{ gap: normalizeSize(16, true) }">
        <StatsCard
            v-for="item in items"
            :key="item.key"
            class="ppv2-flex-1 ppv2-min-w-[200px]"
            :isActive="activeTab === item.key"
            :count="stats[item.countKey] || 0"
            :label="item.label"
            :icon="item.icon"
            @click="$emit('click', item.key)"
        />
    </div>
</template>

<script>
import normalizeSize from '../../../utils/normalizeSize'
import StatsCard from './StatsCard.vue'
import TableIcon from './TableIcon.vue'
import CategoryIcon from './CategoryIcon.vue'

export default {
    name: 'TableStatsNavigation',
    components: { StatsCard },
    props: {
        activeTab: { type: String, required: true },
        stats: { type: Object, required: true },
    },
    computed: {
        items() {
            return [
                { key: 'tables', countKey: 'tables', label: this.$t('food.tables.title'), icon: TableIcon },
                {
                    key: 'table-categories',
                    countKey: 'table_categories',
                    label: this.$t('food.navigation.table_categories'),
                    icon: CategoryIcon,
                },
            ]
        },
    },
    methods: { normalizeSize },
}
</script>
